export default {
  labels: {
    invoice: 'Factura',
    on_site: 'Pagar en el local (Efectivo/Tarjeta)',
  },
};
